import axios from 'axios';
import { getStore, setStore, removeStore } from './storage';
import { router } from '../router/index';
import { Message } from 'view-design';
import Cookies from 'js-cookie';
// 统一请求路径前缀
let base = '/hatch';
 export const API_ROOT = 'https://vex.bqj.cn'; //正式环境
// let API_ROOT = 'https://previpback.bqj.cn' //预发布环境
//let API_ROOT = 'https://tsvc.bqj.cn' //测试环境
//let API_ROOT = 'http://127.0.0.1:18888' //开发环境

// 超时设定
axios.defaults.timeout = 60000;

axios.interceptors.request.use(config => {
    return config;
}, err => {
    toast('请求超时');
    return Promise.resolve(err);
});

// http response 拦截器
axios.interceptors.response.use(response => {
    const data = response.data;
    // 根据返回的code值来做不同的处理(和后端约定)
    if(data.code === 401) {
        Message.error(data.message);
        removeStore('userInfo')
        removeStore('accessToken')
        window.location.reload()
        return false
    } else {
        return data;
    }
    
}, (err) => {
    // 返回状态码不为200时候的错误处理
    // toast('连接错误，请重试');
    return Promise.resolve(err);
});

export const getRequest = (url, params) => {
    let accessToken = getStore('accessToken'); 
    const _header = {
        'withCredentials': true
    }
    if(accessToken){
        _header['accessToken'] = accessToken
    }
    return axios({
        method: 'get',
        url: `${API_ROOT}${base}${url}`,
        params: params,
        headers: {..._header}
    });
};

export const postRequest = (url, params) => {
    let accessToken = getStore("accessToken");
    const _header = {
        'Content-Type': 'application/json',
        'withCredentials': true
    }
    if(accessToken){
        _header['accessToken'] = accessToken
    }
    return axios({
        method: 'post',
        url: `${API_ROOT}${base}${url}`,
        data: params,
        headers: {..._header}
    });
};

export const putRequest = (url, params) => {
    let accessToken = getStore("accessToken");
    return axios({
        method: 'put',
        url: `${API_ROOT}${base}${url}`,
        data: params,
        transformRequest: [function (data) {
            let ret = '';
            for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
            }
            ret = ret.substring(0, ret.length - 1);
            return ret;
        }],
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'accessToken': accessToken
        }
    });
};

export const deleteRequest = (url, params) => {
    let accessToken = getStore('accessToken');
    return axios({
        method: 'delete',
        url: `${API_ROOT}${base}${url}`,
        params: params,
        headers: {
            'accessToken': accessToken
        }
    });
};

export const uploadFileRequest = (url, params) => {
    let accessToken = getStore('accessToken');
    return axios({
        method: 'post',
        url: `${API_ROOT}${base}${url}`,
        params: params,
        headers: {
            'accessToken': accessToken
        }
    });
};

/**
 * 无需token验证的请求 避免旧token过期导致请求失败
 * @param {*} url 
 * @param {*} params 
 */
export const getRequestWithNoToken = (url, params) => {
    return axios({
        method: 'get',
        url: `${API_ROOT}${base}${url}`,
        params: params
    });
};
export const postFZRequest = (url, params) => {
    let accessToken = getStore("accessToken");
    return axios({
        method: 'post',
        url: `${base}${url}`,
        data: params,
        transformRequest: [function (data,config) {
            let ret = '';
            for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
            }
            ret = ret.substring(0, ret.length - 1);
            return ret;
        }],
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'accessToken': accessToken
        }
    });
};
export const postFormRequest = (url, params) => {
    let accessToken = getStore("accessToken");
    return axios({
        method: 'post',
        url: `${base}${url}`,
        data: params,
        transformRequest: [function (data,config) {
            return data;
        }],
        headers: {
            'Content-Type': 'multipart/form-data',
            'accessToken': accessToken
        }
    });
};
//json
export const postJsonRequest = (url, params) => {
    let accessToken = getStore("accessToken");
    return axios({
        method: 'post',
        url: `${base}${url}`,
        data: params,
        transformRequest: [function (data,config) {
            return data;
        }],
        headers: {
            'Content-Type': 'application/json',
            'accessToken': accessToken
        }
    });
};

export const importRequest = (url, params) => {
    let accessToken = getStore('accessToken');
    return axios({
        method: 'post',
        url: `${base}${url}`,
        data: params,
        headers: {
            'accessToken': accessToken
        }
    });
};





// WEBPACK FOOTER //
// ./src/libs/axios.js